var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fee-preferences"},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"md":"8"}},[(_vm.preferences)?_c('div',[_c('div',{staticClass:"ql-editor"},[_c('div',{staticClass:"ma-0 mt-2 ql-editor-fees",domProps:{"innerHTML":_vm._s(_vm.preferences.content)}})])]):_vm._e()])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }